import { Component, Input, ChangeDetectionStrategy, inject } from '@angular/core';
import { Order } from '../../interfaces/orders/order';
import { DischargeDetailsUIConfiguration } from '../../interfaces/ui-configurations/discharge-details-ui-configuration';
import { eDischargeType, eOrderStatusType } from '../../enums';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'lib-discharge-details',
    templateUrl: './discharge-details.component.html',
    styleUrls: ['./discharge-details.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DischargeDetailsComponent {
  private readonly transloco = inject(TranslocoService);
  @Input() order!: Order;
  @Input() uiConfiguration!: DischargeDetailsUIConfiguration;

  getDischargeType(): string {
    return this.order.discharge?.dischargeType == eDischargeType.agreementToDischarge
      ? this.transloco.translate('dischargeDetails.agreementToDischarge')
      : this.transloco.translate('dischargeDetails.totalDischarge')
  }

  isDraft() {
    return this.order.orderStatusTypeID === eOrderStatusType.draft;
  }
}